import React, { useEffect, useState } from "react";
import AdminBlogs from "./blogs";

const BlogHistory = () => {
  const [blogs, setBlogs] = useState([]);
  const [showAddBlog, setShowAddBlog] = useState(false);

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const response = await fetch("https://api.swalokgroup.com/api/get-blogs");
        const data = await response.json();

        if (response.ok) {
          setBlogs(data);
        } else {
          console.error("Failed to fetch blogs", data);
        }
      } catch (error) {
        console.error("Error while fetching sites:", error);
      }
    };

    fetchBlogs();
  }, []);

  const handleDeleteBlog = async (blogId) => {
    try {
      const response = await fetch(
        `https://api.swalokgroup.com/api/delete-blog?blogId=${blogId}`,
        {
          method: "DELETE",
        }
      );

      if (!response.ok) {
        throw new Error("Failed to delete blog");
      }

      setBlogs((prevBlogs) => prevBlogs.filter((s) => s.id !== blogId));
      alert("Blog Deleted Successfully");
    } catch (error) {
      console.log(error.message);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString); // Create Date object
    return date.toLocaleDateString(); // Default format is 'MM/DD/YYYY' in the browser's locale
  };

  return (
    <>
      <section className="py-5">
        <div className="container">
          <div className="sec-subheading">
            <hr />
            <span>Recent Blogs Posted</span>
            <hr />
          </div>
          <button
            className="admin-btn px-3 py-2 mt-3 rounded"
            onClick={() => setShowAddBlog(true)}
          >
            Post Blog &nbsp;
            <i className="fa-solid fa-pen-nib"></i>
          </button>

          {showAddBlog && <AdminBlogs setShowAddBlog={setShowAddBlog} />}

          <div className="row mt-5">
            {blogs.length > 0 ? (
              blogs.map((blog) => (
                <>
                  <div className="col-lg-4 my-2 px-lg-0">
                    <img
                      src={`https://api.swalokgroup.com/uploads/${blog.blog_image}`}
                      className="blog-img"
                      alt="blog"
                    />
                  </div>

                  <div className="col-lg-8 col-12 my-2 text-start">
                    <div className="blog-content h-100 py-4 px-4">
                      <p className="fs-5 fw-bold">{blog.blog_title}</p>
                      <hr />
                      <p className="text-muted para-text fst-italic">
                        Posted on: {formatDate(blog.posted_on)}
                      </p>
                      <p className="text-muted">{blog.blog_description}</p>
                      <button
                        className="admin-btn bg-danger rounded px-2 py-2"
                        onClick={() => handleDeleteBlog(blog.id)}
                      >
                        Delete Blog <i className="fa-solid fa-trash-can"></i>
                      </button>
                    </div>
                  </div>
                </>
              ))
            ) : (
              <p>No Blogs available</p>
            )}
          </div>
          {/* row ends */}
        </div>
      </section>
    </>
  );
};

export default BlogHistory;
